import { render, staticRenderFns } from "./AccessoRapportiUtenzaBUTable.vue?vue&type=template&id=6a32892a&scoped=true&"
import script from "./AccessoRapportiUtenzaBUTable.vue?vue&type=script&lang=js&"
export * from "./AccessoRapportiUtenzaBUTable.vue?vue&type=script&lang=js&"
import style0 from "./AccessoRapportiUtenzaBUTable.vue?vue&type=style&index=0&id=6a32892a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a32892a",
  null
  
)

component.options.__file = "AccessoRapportiUtenzaBUTable.vue"
export default component.exports